import { Notification, ArticleSummary, CommitteeConfig, Configuration, Legislation, LegislationDoc, LegislationFilter, LegislationList, LegislationSummary, LoginResponse, NewsConfig, RecentLegislationList, Story, StoryList, ApiResult, RecentLegislation, VerifyLoginCodeResponse, RefreshResponse, SubscribedLegislation, SubscribedLegislationList, LegislationEvent } from "./models";
import Storage from "./storage";

export default class Api {
    public static getStories(page?: number, limit?: number, source?: number): Promise<ApiResult<StoryList|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/stories?page=${page}&limit=${limit}&source=${source}`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        }
                    }
                );
                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: (data as unknown) as StoryList,
                        Error: null
                    })
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    });
                }

            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                });
            }
        });
    }

    public static getStory(hash: string): Promise<ApiResult<Story|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/stories/${hash}`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        }
                    }
                );
                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: (data as unknown) as Story,
                        Error: null
                    })
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    })
                }

            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                })
            }
        });
    }

    public static getLegislations(page?: number, limit?: number, filter?: LegislationFilter): Promise<ApiResult<LegislationList|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/legislation?page=${page}&limit=${limit}&committee=${filter?.committee}&searchText=${filter && filter.searchText? filter.searchText : ""}`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        }
                    }
                );
                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: (data as unknown) as LegislationList,
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    });
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                });
            }
        })
    }

    public static getLegislationByHash(hash: string): Promise<ApiResult<Legislation|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/legislation/hash/${hash}`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        }
                    }
                );
                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: (data as unknown) as Legislation,
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    });
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                });
            }
        })
    }

    public static getLegislationById(id: number): Promise<ApiResult<Legislation|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/legislation/id/${id}`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        }
                    }
                );
                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: (data as unknown) as Legislation,
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    });
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                });
            }
        })
    }

    public static getMyProjects(page?: number, limit?: number, category?: string): Promise<ApiResult<SubscribedLegislationList|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/legislation/subscribed?page=${page}&limit=${limit}&searchText=${category}`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        }
                    }
                );
                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: (data as unknown) as SubscribedLegislationList,
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    });
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                });
            }
        })
    }

    public static getLegislationEvents(legislationId: number): Promise<ApiResult<LegislationEvent[]|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/legislation/events/${legislationId}/`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        }
                    }
                );
                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: (data as unknown) as LegislationEvent[],
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    });
                }
            } catch (error) {
                console.log(error);
                resolve({
                    Data: null,
                    Error: error
                });
            }
        });
    }

    public static searchSubscribedProjects(page?: number, limit?: number, filter?: LegislationFilter): Promise<ApiResult<SubscribedLegislationList|null>> {
        return new Promise(async (resolve) => {
            try {

                const committeeParams = new URLSearchParams();
                let committeeQuery = "";
                if(filter && filter.committees && filter.committees.length > 0) {
                    for(let i=0; i < filter.committees.length; i++) {
                        committeeParams.append('committee', filter.committees[i].toString());
                    }
                    committeeQuery = `&${committeeParams.toString()}`;
                }

                const response = await fetch(`${process.env.REACT_APP_API_URL}/legislation/subscribed/search?page=${page}&limit=${limit}&searchText=${filter?.searchText}${committeeQuery}&category=${filter?.category}`,
                    {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        }
                    }
                );
                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: (data as unknown) as SubscribedLegislationList,
                        Error: null
                    })
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    });
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                });
            }
        })
    }

    public static updateSubscribedProjectTags(legislationId: number, tags: string[]): Promise<ApiResult<boolean|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/legislation/subscribed/tags`,
                    {
                        headers: {                            
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        },
                        method: "POST",
                        body: JSON.stringify({
                            legislationId,
                            tags
                        })
                    }
                );
                if(response.ok) {
                    resolve({
                        Data: true,
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: false,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    });
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                });
            }
        })
    }

    public static getRecentLegislations(page?: number, limit?: number, filter?: LegislationFilter): Promise<ApiResult<RecentLegislationList|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/recentlegislation?page=${page}&limit=${limit}&committee=${filter?.committee}`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        }
                    }
                );
                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: (data as unknown) as RecentLegislationList,
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    });
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                });
            }
        })
    }

    public static searchLegislation(searchText: string, page?: number, limit?: number): Promise<ApiResult<LegislationList|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/legislation/search?page=${page}&limit=${limit}&searchText=${searchText}`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        }
                    }
                );
                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: (data as unknown) as LegislationList,
                        Error: null
                    })
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    });
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                });
            }
        })
    }

    public static summarizeArticle(storyId: number): Promise<ApiResult<ArticleSummary|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/summarize/article/${storyId}`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        },
                        method: "GET"
                    }
                );

                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: (data as unknown) as ArticleSummary,
                        Error: null
                    })
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    });
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                });
            }
        })
    }

    public static summarizeLegislation(legislationId: number): Promise<ApiResult<LegislationSummary|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/summarize/legislation/${legislationId}`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        },
                        method: "POST"
                    }
                );

                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: (data as unknown) as LegislationSummary,
                        Error: null
                    })
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    });
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                })
            }
        })
    }

    public static summarizeLegislationDoc(docId: number): Promise<ApiResult<LegislationSummary|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/summarize/legislation/doc/${docId}`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        },
                        method: "GET"
                    }
                );

                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: data as LegislationSummary,
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    })
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                })
            }
        })
    }

    public static summarizeRecentLegislationDoc(legislationId: number): Promise<ApiResult<LegislationSummary|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/summarize/recentlegislation/${legislationId}`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        },
                        method: "GET"
                    }
                );

                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: data as LegislationSummary,
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    });
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                })
            }
        })
    }

    public static getConfig(): Promise<ApiResult<Configuration|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/config`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        },
                        method: "GET"
                    }
                );

                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: data as Configuration,
                        Error: null
                    })
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    });
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                })
            }
        })
    }

    public static updateCommitteeConfig(committees: CommitteeConfig[]): Promise<ApiResult<Configuration|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/config/committees`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        },
                        method: "POST",
                        body: JSON.stringify(committees)
                    }
                );

                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: data as Configuration,
                        Error: null
                    })
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    })
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                })
            }
        })
    }

    public static updateNewsConfig(news: NewsConfig[]): Promise<ApiResult<Configuration|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/config/news`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        },
                        method: "POST",
                        body: JSON.stringify(news)
                    }
                );

                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: data as Configuration,
                        Error: null
                    })
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    })
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                })
            }
        })
    }

    // public static updateProjectEventsConfig(projects: number[]): Promise<ApiResult<Configuration|null>> {
    //     return new Promise(async (resolve) => {
    //         try {
    //             const response = await fetch(`${process.env.REACT_APP_API_URL}/config/project/events`,
    //                 {
    //                     headers: {
    //                         'Content-Type': 'application/json',
    //                         'Authorization': `Bearer ${Storage.getSessionToken()}`
    //                     },
    //                     method: "POST",
    //                     body: JSON.stringify(projects)
    //                 }
    //             );

    //             if(response.ok) {
    //                 const data = await response.json();
    //                 resolve({
    //                     Data: data as Configuration,
    //                     Error: null
    //                 })
    //             }
    //             else {
    //                 resolve({
    //                     Data: null,
    //                     Error: new Error(`HTTP error! status: ${response.status}`)
    //                 })
    //             }
    //         } catch (error) {
    //             resolve({
    //                 Data: null,
    //                 Error: error
    //             })
    //         }
    //     })
    // }
    public static updateSubscribedProjects(legislationId: number): Promise<ApiResult<boolean|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/legislation/subscribed`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        },
                        method: "POST",
                        body: JSON.stringify({
                            legislationId
                        })
                    }
                );

                if(response.ok) {
                    resolve({
                        Data: true,
                        Error: null
                    })
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    })
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                })
            }
        })
    }

    public static register(email: string): Promise<ApiResult<string|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/register`,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        method: "POST",
                        body: JSON.stringify({
                            email
                        })
                    }
                );

                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: data.codeId,
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    })
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                })
            }
        });
    }

    public static confirmAccount(codeId: string, code: number): Promise<ApiResult<boolean|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/confirm-account`,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        method: "POST",
                        body: JSON.stringify({
                            codeId,
                            code
                        })
                    }
                );

                if(response.ok) {
                    resolve({
                        Data: true,
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    })
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                })
            }
        });
    }

    public static resendAccountConfirmationCode(codeId: string): Promise<ApiResult<string|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/resend-account-confirmation-code`,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        method: "POST",
                        body: JSON.stringify({
                            codeId
                        })
                    }
                );

                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: data.codeId,
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    });
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                });
            }
        });
    }

    public static login(email: string): Promise<ApiResult<LoginResponse|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/login`,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        method: "POST",
                        body: JSON.stringify({
                            email
                        })
                    }
                );

                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: data as LoginResponse,
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    })
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                })
            }
        });
    }

    public static logout(): Promise<ApiResult<boolean|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/logout`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        },
                        method: "POST",
                    }
                );

                if(response.ok) {
                    resolve({
                        Data: true,
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    })
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                })
            }
        });
    }

    public static verifyLoginCode(codeId: string, code: number): Promise<ApiResult<VerifyLoginCodeResponse|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/verify-login-code`,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        method: "POST",
                        body: JSON.stringify({
                            codeId,
                            code
                        })
                    }
                );

                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: data as VerifyLoginCodeResponse,
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    })
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                })
            }
        });
    }

    public static resendLoginVerificationCode(email: string): Promise<ApiResult<string|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/resend-login-verification-code`,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        method: "POST",
                        body: JSON.stringify({
                            email
                        })
                    }
                );

                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: data.CodeId,
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    })
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                })
            }
        });
    }

    public static verifyCode(code: number): Promise<ApiResult<boolean|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/verify-code`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        },
                        method: "POST",
                        body: JSON.stringify({
                            code
                        })
                    }
                );

                if(response.ok) {
                    resolve({
                        Data: true,
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    })
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                })
            }
        });
    }

    public static resendVerificationCode(): Promise<ApiResult<boolean|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/resend-verification-code`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        },
                        method: "POST"
                    }
                );

                if(response.ok) {
                    resolve({
                        Data: true,
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    })
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                })
            }
        });
    }

    public static refreshToken(): Promise<ApiResult<RefreshResponse|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/refresh-token`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        },
                        method: "POST"
                    }
                );

                if (response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: data as RefreshResponse,
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    })
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                })
            }
        });
    }

    public static getNotifications(): Promise<ApiResult<Notification[]|null>> {
        return new Promise(async (resolve) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/notifications`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        },
                        method: "GET"
                    }
                );

                if(response.ok) {
                    const data = await response.json();
                    resolve({
                        Data: data.Notifications as Notification[],
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    })
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                })
            }
        });
    }
    public static markNotificationAsRead(notifId: number): Promise<ApiResult<boolean|null>> {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/mark-notification-as-read`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Storage.getSessionToken()}`
                        },
                        method: "POST",
                        body: JSON.stringify({
                            notifId  
                        })
                    }
                );

                if(response.ok) {
                    resolve({
                        Data: true,
                        Error: null
                    });
                }
                else {
                    resolve({
                        Data: null,
                        Error: new Error(`HTTP error! status: ${response.status}`)
                    })
                }
            } catch (error) {
                resolve({
                    Data: null,
                    Error: error
                })
            }
        });
    }
}